import { Select, Skeleton } from "antd";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { columnChartConfigurationOptions } from "../../config";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

function TicketByAge({ projects }) {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([]);
    const [chartResults, setChartResults] = useState([]);
    const [assignee, setAssignee] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        workauthor_id: "",
    });
    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "ticketByAge",
        async () => {
            return await HTTP("/analytics/getJiraTicketsByAgeChart", {
                ...formData,
            });
        },
        { enabled: false },
    );

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => {
            return await HTTP("/analytics/getJiraAssignees", { staff_id });
        },
        { enabled: false },
    );

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);

    useEffect(() => {
        getChart();
    }, [formData]);

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        if (chartStatus === "success") {
            const { data } = chartRes;
            setChartResults(data);
            const ticketsByAgeNew = [["Range", "Tickets"]];

            data.map((e) => {
                ticketsByAgeNew.push([e.range, e.tickets]);
                return 0;
            });
            setChartData(ticketsByAgeNew);
        }
    }, [chartStatus, chartRes]);

    function handleProjectSelectionChange(e) {
        let project_id = -1;
        if (e !== undefined) {
            [project_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            project_id,
        };
        setFormData(updatedFormData);
    }

    function handleAssigneeSelectionChange(e) {
        let workauthor_id = "";
        if (e !== undefined) {
            [workauthor_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            workauthor_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    className="jira-dashboard-select"
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    className="jira-dashboard-select"
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </div>
            {chartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="BarChart"
                    height="45vh"
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Tickets By Age",
                    }}
                    data={chartData}
                    chartEvents={[
                        {
                            eventName: "ready",
                            callback: ({ chartWrapper, google }) => {
                                const chart = chartWrapper.getChart();
                                google.visualization.events.addListener(
                                    chart,
                                    "select",
                                    () => {
                                        const [selection] =
                                            chart.getSelection();
                                        if (selection) {
                                            const { row } = selection;
                                            const { id } = chartResults[row];
                                            navigate(
                                                `/jira-dashboard/tickets/${id}`,
                                            );
                                        }
                                    },
                                );
                            },
                        },
                    ]}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}
export default TicketByAge;
